import {
  Card,
  Collection,
  Flex,
  Heading,
  ScrollView,
} from "@aws-amplify/ui-react";
import React from "react";
import { Team } from "../../game/Types/TeamTypes";
import { useTranslationContext } from "../../../context";
import LeaderboardResult from "./LeaderboardResult";
import { Player } from "../../game/Types/GameTypes_dep";

export default function Leaderboard({
  teams,
  players,
}: {
  teams: Team[];
  players: Player[];
}) {
  const { translations } = useTranslationContext();

  return (
    <>
      <Card boxShadow={"large"}>
        <Heading paddingBottom={"xs"}>{translations.leaderboard}</Heading>
        <Flex direction="column" gap={"small"}>
          <ScrollView>
            <Collection
              items={teams}
              type="list"
              padding={{ base: "xxs", medium: "large" }}
            >
              {(assignmentResult, i) => (
                <LeaderboardResult
                  key={i}
                  team={assignmentResult}
                  i={i}
                  players={players}
                />
              )}
            </Collection>
          </ScrollView>
        </Flex>
      </Card>
    </>
  );
}
